<div class="sidebar">
  <div class="upload-prescription">
    <div>
      <h4 class="upload-prescription-title">Upload Prescription</h4>
      <p>Please upload your prescription below and our customer service team will get back to you shortly.</p>
      <button class="sigma_btn btn btn-sm" (click)="openPrescriptionForm()">Upload Prescription</button>
    </div>
  </div>
</div>
